/**
 * №29 (S1) — THE CHAT SUBJECT (mockup A): the stage IS the conversation.
 *
 * David's original question was *"is the most dramatic UI change about inverting the
 * chat to be centre page?"*, and the probe's answer was "half": inverting is right,
 * inverting **to chat permanently** is not, because a matter has money, parties,
 * obligations and deadlines that chat would hide. So chat is one subject the stage can
 * hold, chosen per surface — and this route is that choice made.
 *
 * ## Why this page renders (almost) nothing
 *
 * The conversation is not this page's content. It is the ONE `CoPanel` the shell
 * already mounts, re-parented into the slot below — see `conversation-host.tsx`. This
 * page's whole job is to claim that slot while it is on screen, and to release it on
 * the way out, so that promoting a live conversation to the stage and demoting it back
 * costs nothing: same component, same runtime, same messages, different chair.
 *
 * Everything else about this surface is already declared elsewhere and must not be
 * restated here — the anchor, the chat scope and the page context come from the
 * matrix row this route was promoted from (`conversationRow`), and the stage head and
 * the work rail read that same row. A conversation route that re-derived any of them
 * would be the №22.3.2 F1 defect with a new URL.
 */
import { useConversationSlot } from "../../components/collab/conversation-host";
import { useCoPanel } from "../../components/collab/co-panel-context";
import { useStageHead } from "./stage-head";

export function ChatSubjectPage() {
  const stageSlot = useConversationSlot("stage");
  // №29 (S2, Q3 → B) — the stage head names the anchor now, so it also has to name
  // the RUN when the conversation is on one. Without this, promoting a conversation
  // that is following a run would drop the run's name entirely: the panel stopped
  // saying it (Q3) and nothing else was saying it. The panel's own header used
  // exactly this value (`focused.label ?? focused.agentName`), so the words do not
  // change — only which band carries them.
  const focused = useCoPanel().focusedTask;
  const title = focused ? (focused.label ?? focused.agentName ?? null) : null;
  useStageHead({ title });
  return <div className="chatstage" data-testid="chat-stage" ref={stageSlot} />;
}
